export const allParams = (state = [], action) => {
    switch (action.type) {
        case 'ALL_PARAMS':
            return action.payload;
        default:
            return state;
    }
};

export const selectedParams = (state = [], action) => {
    switch (action.type) {
        case 'SELECTED_PARAMS':
            return action.payload;
        default:
            return state;
    }
};
export const symboledParams = (state = [], action) => {
    switch (action.type) {
        case 'SYMBOLED_PARAMS':
            return action.payload;
        default:
            return state;
    }
};
export const conditionsParams = (state = [], action) => {
    switch (action.type) {
        case 'CONDITION_PARAMS':
            return action.payload;
        default:
            return state;
    }
};
